import React from 'react';
import style from './style.scss';//NOSONAR


const MethodPay = () => {

    return (
        <ul className='footer-nav-links method-pay'>
            <li className="footer-method-pay-icon"><i className="jumbo-icon-new-cencosud-card"></i></li>
            <li className="footer-method-pay-icon"><i className="jumbo-icon-new-mastercard"></i></li>
            <li className="footer-method-pay-icon"><i className="jumbo-icon-new-visa"></i></li>
            <li className="footer-method-pay-icon"><i className="jumbo-icon-new-magna"></i></li>
            <li className="footer-method-pay-icon "><i className="jumbo-icon-new-amex"></i></li>
            <li className="footer-method-pay-icon"><i className="jumbo-icon-new-diners"></i></li>
            <li className="footer-method-pay-icon"><i className="jumbo-icon-new-redcompra"></i></li>
        </ul>
    )
}

export default MethodPay;